import logger from "@utils/logger";
import type {
  ILivechatMessage,
  ILivechatMessageType,
  WebsocketMessageExtraReplyMarkup,
} from "@utils/types";
import type { WebsocketMessage, WebsocketMessageType } from "./types";

function getExtraReplyMarkup(
  text?: string | null
): WebsocketMessageExtraReplyMarkup | undefined {
  try {
    if (text) return JSON.parse(text);
  } catch {}
}

/**
 * return Date.now() and avoid duplicated timestamps
 */
const getTimestamp = (() => {
  let prevTime = 0;

  return () => {
    let time = Date.now();
    if (prevTime === time) time += 1;

    prevTime = time;

    return time;
  };
})();

export function transformWebsocketMessageToLivechatMessage(
  wsMessage: WebsocketMessage<"incoming">
): ILivechatMessage {
  logger.debug("< incoming:message", wsMessage);

  const menu = getExtraReplyMarkup(wsMessage.extraReplyMarkup);

  const type =
    typeof wsMessage.type === "string"
      ? menu
        ? "menu"
        : (wsMessage.type
            .replace(/_MESSAGE$/g, "")
            .toLowerCase() as ILivechatMessageType)
      : "internal";

  return {
    from: "incoming",
    type,
    ...(type === "text" || type === "menu"
      ? { text: wsMessage.message }
      : { url: wsMessage.message }),
    ...(wsMessage.agentAvatar && {
      avatar: wsMessage.agentAvatar,
      name: wsMessage.agentName || "",
    }),
    ...(menu && {
      menu: {
        checked: -1,
        options: menu.inline_keyboard[0].map(option => ({
          label: option.text,
          callback: option.callback_data,
        })),
      },
    }),
    timestamp: getTimestamp(),
  };
}

export function transformLivechatMessageToWebsocketMessage(
  livechatMessage: ILivechatMessage,
  { contactId, token }: Record<"contactId" | "token", string>
): WebsocketMessage<"outgoing"> {
  const type =
    `${livechatMessage.type.toUpperCase()}_MESSAGE` as WebsocketMessageType;

  const message_ =
    (livechatMessage.menu
      ? livechatMessage.menu.options[livechatMessage.menu.checked].callback
      : type === "TEXT_MESSAGE"
      ? livechatMessage.text
      : livechatMessage.url) || "";

  const wsMessage = {
    contactId: contactId,
    merchantId: token,
    type,
    message: message_,
  };

  logger.debug("outgoing:message >", wsMessage);

  return wsMessage;
}
